import React from "react";
import { graphql, Link } from 'gatsby';
import Layout from "../components/layout";
import FluidImage from "../components/fluidImage";
import FixedImage from "../components/fixedImage";
import WPLink from "../components/wpLink";
import DroidalLink from "../components/droidalLink";
import Seo from 'gatsby-plugin-wpgraphql-seo';
import useModalState from '../helpers/modalState';

import * as styleSheet from "./page.module.scss"

const PageTemplate = (props) => {

  const [showAppointmentModal, setShowAppointmentModal] = useModalState();

  function showModal(){
		if( !showAppointmentModal.modalOpen ){
			setShowAppointmentModal({
                modalOpen: true, 
                zipcode: showAppointmentModal.zipcode,
                greyfinchId: showAppointmentModal.greyfinchId,
                showCallCenterModalOnClose: showAppointmentModal.showCallCenterModalOnClose,
                callCenterModalOpen: showAppointmentModal.callCenterModalOpen
            });
		}
	}

  function handleApptKeyDown(e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
        setShowAppointmentModal({
            modalOpen: true, 
            zipcode: showAppointmentModal.zipcode,
            greyfinchId: showAppointmentModal.greyfinchId,
            showCallCenterModalOnClose: showAppointmentModal.showCallCenterModalOnClose,
            callCenterModalOpen: showAppointmentModal.callCenterModalOpen
        });
		}
  }

	const {
		data: {
			pageInfo,
			pageInfo: {
				title,
				ACFPageInfo: {
					pageInfo: {
						left: {
							blurb,
							requestAppointmentLink,
							insurancesHeading,
              insurancesGroup: {
                associateThisPageWithALocation,
                insurances: chosenInsurances,
                associateWithLocation: associatedInsurancesLocation
              },
							callout: {
								backgroundImage: calloutBG,
								blurb: calloutBlurb,
								heading: calloutHeading,
								link: calloutLink
							}
						},
						right: {
              heroBackgroundImage,
							introContent: {
								blurb: introBlurb,
								heading: introHeading,
								link: introLink
							},
							pageContent: content,
						}
					}
				}
			},
			home: {
				ACFHomePage: {
					hero: {
						callouts: {
							callout1: {
								heading: homeCalloutHeading,
								blurb: homeCalloutBlurb,
								makeAnAppointmentLinkText
							}
						}
					}
				}
			},
			options: {
				headerSection: {
					ACFHeaderOptions: {
						mainNavigationSettings: {
              mobileNavigationLogo
						} 
					}
				}

			},
			insurance: {
				nodes: insurances
			},
			rightArrowYellow,
			introBGMobile,
			introBGTablet,
			introBGDesktop,
			introBGXL,
			calloutBG: genericCalloutBG
		}
	} = props;



  const associatedLocationInsurances = associateThisPageWithALocation && associatedInsurancesLocation ? associatedInsurancesLocation[0].ACFLocation.locationInfo.left.insurances : false


	return (
		<Layout>
			<Seo post={pageInfo} />
			<div className={styleSheet.top}>
				<div className={styleSheet.left}>
					<div className={styleSheet.lefttop}>
						{ mobileNavigationLogo && <Link to="/" className={styleSheet.logolink}><FluidImage image={mobileNavigationLogo} passedClass={styleSheet.logo} loading={"eager"} /></Link>}
						<h1 className={styleSheet.patientname} dangerouslySetInnerHTML={{__html: title}}></h1>
					</div>
					<div className={styleSheet.leftbottom}>
						{ blurb && <div className={styleSheet.patientheading} dangerouslySetInnerHTML={{__html: blurb}}></div> }
            { requestAppointmentLink && requestAppointmentLink.url.includes('schedule-online') && !requestAppointmentLink?.url.includes('tel:') && <DroidalLink text={requestAppointmentLink.title} passedClass={styleSheet.request} />}
            { requestAppointmentLink && !requestAppointmentLink.url.includes('schedule-online') && requestAppointmentLink?.url.includes('tel:') && <a href={requestAppointmentLink.url} className={styleSheet.request} target={requestAppointmentLink.target}>{requestAppointmentLink.title}</a> }
						{ requestAppointmentLink && !requestAppointmentLink.url.includes('schedule-online') && !requestAppointmentLink?.url.includes('tel:') && <WPLink link={requestAppointmentLink} passedClass={styleSheet.request} /> }
						{ !requestAppointmentLink && <DroidalLink text="Make an appointment" passedClass={styleSheet.request} /> }
					</div>
				</div>
				<div className={styleSheet.right}>
          {heroBackgroundImage && <FluidImage image={heroBackgroundImage} passedClass={styleSheet.bgmobile} loading={"eager"} /> }
          {heroBackgroundImage && <FluidImage image={heroBackgroundImage} passedClass={styleSheet.bgtablet} loading={"eager"} /> }
          {heroBackgroundImage && <FluidImage image={heroBackgroundImage} passedClass={styleSheet.bgdesktop} loading={"eager"} /> }
          {heroBackgroundImage && <FluidImage image={heroBackgroundImage} passedClass={styleSheet.bgxl} loading={"eager"} /> }
          
          { !heroBackgroundImage && introBGMobile && <FluidImage image={introBGMobile} passedClass={styleSheet.bgmobile} loading={"eager"} /> }
          { !heroBackgroundImage && introBGTablet && <FluidImage image={introBGTablet} passedClass={styleSheet.bgtablet} loading={"eager"} /> }
					{ !heroBackgroundImage && introBGDesktop && <FluidImage image={introBGDesktop} passedClass={styleSheet.bgdesktop} loading={"eager"} /> }
					{ !heroBackgroundImage && introBGXL && <FluidImage image={introBGXL} passedClass={styleSheet.bgxl} loading={"eager"} /> }

					{ mobileNavigationLogo && <Link to="/" className={styleSheet.logolink}><FluidImage image={mobileNavigationLogo} passedClass={styleSheet.logo} loading={"eager"} /></Link>}
					<h1 className={styleSheet.patientname} dangerouslySetInnerHTML={{__html: title}}></h1>
					{ introHeading && <div className={styleSheet.heading} dangerouslySetInnerHTML={{__html: introHeading}} data-sal="slide-up" data-sal-delay="200" data-sal-easing="ease-in"></div> }
					{ introBlurb && <div className={styleSheet.blurb} dangerouslySetInnerHTML={{__html: introBlurb}} data-sal="slide-up" data-sal-delay="300" data-sal-easing="ease-in"></div> }
					
          { introLink && !introLink?.url.includes('schedule-online') && !introLink?.url.includes('tel:') && <WPLink link={introLink} icon={rightArrowYellow} passedClass={styleSheet.link} passedIconClass={styleSheet.icon} data-sal="slide-up" data-sal-delay="400" data-sal-easing="ease-in" />}
          { introLink && !introLink?.url.includes('schedule-online') && introLink?.url.includes('tel:') && <a target={introLink.target} href={introLink.url} class={styleSheet.link} data-sal="slide-up" data-sal-delay="400" data-sal-easing="ease-in">{introLink.title} <FixedImage image={rightArrowYellow} passedClass={styleSheet.icon} /></a> }
          { introLink && introLink?.url.includes('schedule-online') && <DroidalLink text={introLink?.title} passedClass={styleSheet.link} icon={rightArrowYellow} passedIconClass={styleSheet.icon} /> }

				</div>
			</div>
			<div className={styleSheet.bottom}>
				<div className={styleSheet.left}>
					<div className={styleSheet.insurance}>
						<span className={styleSheet.heading}>{ insurancesHeading ? insurancesHeading : 'We accept the following insurance.' }</span>
						<div className={styleSheet.insurancebottom}>

              {associateThisPageWithALocation && associatedInsurancesLocation && associatedLocationInsurances && associatedLocationInsurances.map( (insurance, index) => {
								const image = insurance.ACFInsurance.logo;
								return image ? <FluidImage key={`insuranceimg-${index}`} image={image} passedClass={styleSheet.insuranceimage} /> : null;
							})}

              {!associateThisPageWithALocation && chosenInsurances ? chosenInsurances.map( (insurance, index) => {
								const image = insurance.ACFInsurance.logo;
								return image ? <FluidImage key={`insuranceimg-${index}`} image={image} passedClass={styleSheet.insuranceimage} /> : null;
							}) : !associateThisPageWithALocation && insurances ? insurances.map( (insurance, index) => {
								const image = insurance.ACFInsurance.logo;
								return image ? <FluidImage key={`insuranceimg-${index}`} image={image} passedClass={styleSheet.insuranceimage} /> : null;
							}) : null}

						</div>
					</div>
					<div className={styleSheet.callout}>
						<div className={styleSheet.left}>
							{ (genericCalloutBG || calloutBG) && <FluidImage image={calloutBG ? calloutBG : genericCalloutBG} passedClass={styleSheet.bg} /> }
						</div>
						<div className={styleSheet.right}>
							{ (calloutHeading || homeCalloutHeading) && <div className={styleSheet.heading} dangerouslySetInnerHTML={{__html: calloutHeading ? calloutHeading : homeCalloutHeading }}></div> }
							{ (calloutBlurb || homeCalloutBlurb) && <div className={styleSheet.blurb} dangerouslySetInnerHTML={{__html: calloutBlurb ? calloutBlurb : homeCalloutBlurb}}></div> }
							{calloutLink && <WPLink link={calloutLink} passedClass={styleSheet.link} />}
              { !calloutLink && makeAnAppointmentLinkText && <DroidalLink text={makeAnAppointmentLinkText} passedClass={styleSheet.link} />}
						</div>
					</div>
				</div>
				<div className={styleSheet.right}>
					<div className={styleSheet.patientcontent}>
						<div className={styleSheet.contentleft}>
							{ content && <div className="wpcontent" dangerouslySetInnerHTML={{__html: content}}></div> }
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
};

export const query = graphql`query ($id: String!) {
  pageInfo: wpPage(id: {eq: $id}) {
    seo {
      title
      metaDesc
      focuskw
      metaKeywords
      metaRobotsNoindex
      metaRobotsNofollow
      opengraphTitle
      opengraphDescription
      opengraphImage {
        altText
        sourceUrl
        srcSet
      }
      twitterTitle
      twitterDescription
      twitterImage {
        altText
        sourceUrl
        srcSet
      }
      canonical
      cornerstone
      schema {
        articleType
        pageType
        raw
      }
    }
    id
    title
    ACFPageInfo {
      pageInfo {
        left {
          blurb
          insurancesHeading
          insurancesGroup {
            associateThisPageWithALocation
            associateWithLocation {
              ... on WpLocation {
                id
                ACFLocation {
                  locationInfo {
                    left {
                      insurances {
                        ... on WpInsurance {
                          id
                          ACFInsurance {
                            logo {
                              altText
                              localFile {
                                childImageSharp {
                                  gatsbyImageData(layout: FULL_WIDTH)
                                }
                                publicURL
                                extension
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            insurances {
              ... on WpInsurance {
                id
                ACFInsurance {
                  logo {
                    altText
                    localFile {
                      childImageSharp {
                        gatsbyImageData(layout: FULL_WIDTH)
                      }
                      publicURL
                      extension
                    }
                  }
                }
              }
            }
          }
          requestAppointmentLink {
            title
            url
            target
          }
          callout {
            backgroundImage {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
                }
                publicURL
                extension
              }
            }
            blurb
            heading
            link {
              target
              title
              url
            }
          }
        }
        right {
          heroBackgroundImage {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 840, layout: CONSTRAINED)
              }
            }
          }
          introContent {
            blurb
            heading
            link {
              target
              title
              url
            }
          }
          pageContent
        }
      }
    }
  }
  home: wpPage(isFrontPage: {eq: true}) {
    ACFHomePage {
      hero {
        callouts {
          callout1 {
            heading
            blurb
            makeAnAppointmentLinkText
          }
        }
      }
    }
  }
  options: wp {
    headerSection {
      ACFHeaderOptions {
        mainNavigationSettings {
          mobileNavigationLogo {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(width: 420, layout: CONSTRAINED, quality: 100)
              }
              publicURL
              extension
            }
          }
        }
      }
    }
  }
  rightArrowYellowOffsite: file(name: {eq: "arrow_offsite"}) {
    childImageSharp {
      gatsbyImageData(width: 10, layout: FIXED)
    }
  }
  rightArrowYellow: file(name: {eq: "arrow"}) {
    childImageSharp {
      gatsbyImageData(width: 9, layout: FIXED)
    }
  }
  arrowBlue: file(name: {eq: "arrow_blue"}) {
    childImageSharp {
      gatsbyImageData(width: 9, layout: FIXED)
    }
  }
  introBGMobile: file(name: {eq: "patientinfobg"}) {
    childImageSharp {
      gatsbyImageData(width: 699, layout: CONSTRAINED)
    }
  }
  introBGTablet: file(name: {eq: "patientinfobg"}) {
    childImageSharp {
      gatsbyImageData(width: 550, layout: CONSTRAINED)
    }
  }
  introBGDesktop: file(name: {eq: "patientinfobg"}) {
    childImageSharp {
      gatsbyImageData(width: 840, layout: CONSTRAINED)
    }
  }
  introBGXL: file(name: {eq: "patientinfobg"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  calloutBG: file(name: {eq: "callout_overlay_girl"}) {
    childImageSharp {
      gatsbyImageData(width: 295, layout: CONSTRAINED)
    }
  }
  insurance: allWpInsurance {
    nodes {
      ACFInsurance {
        logo {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 420, layout: CONSTRAINED)
            }
            publicURL
            extension
          }
        }
      }
    }
  }
}
`;

export default PageTemplate;